import { motion } from "framer-motion";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

export const Manifesto = ({ t }) => (
  <section id="why" className="relative mx-auto max-w-[1440px] px-5 py-28 md:px-10 md:py-40" data-testid="manifesto-section">
    <motion.p {...reveal} className="mb-6 font-mono-spec text-[11px] uppercase tracking-[0.3em] text-[#00e5ff]" data-testid="manifesto-kicker">
      / {t.kicker}
    </motion.p>
    <motion.h2 {...reveal} className="max-w-4xl font-display text-3xl font-semibold leading-tight tracking-tight md:text-5xl" data-testid="manifesto-title">
      {t.title}
    </motion.h2>
    <motion.p {...reveal} className="mt-8 max-w-2xl text-base leading-relaxed text-slate-400">
      {t.intro}
    </motion.p>

    <div className="mt-20 grid gap-px overflow-hidden rounded border border-white/10 bg-white/10 md:grid-cols-2">
      {t.chapters.map((c, i) => (
        <motion.div
          key={c.n}
          {...reveal}
          transition={{ ...reveal.transition, delay: i * 0.08 }}
          className="group relative bg-[#050b1a] p-8 transition-colors duration-500 hover:bg-[#081226] md:p-12"
          data-testid={`manifesto-chapter-${c.n}`}
        >
          <span className="text-outline font-display text-7xl font-extrabold transition-all duration-500 group-hover:[-webkit-text-stroke-color:rgba(0,229,255,0.5)] md:text-8xl">
            {c.n}
          </span>
          <h3 className="mt-6 font-display text-lg font-semibold uppercase tracking-wide text-slate-50 md:text-xl">{c.title}</h3>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">{c.body}</p>
        </motion.div>
      ))}
    </div>

    <div className="mt-px grid grid-cols-2 gap-px overflow-hidden rounded-b border border-t-0 border-white/10 bg-white/10 lg:grid-cols-4">
      {t.stats.map((s, i) => (
        <motion.div
          key={s.l}
          {...reveal}
          transition={{ ...reveal.transition, delay: i * 0.06 }}
          className="bg-[#050b1a] p-6 md:p-8"
          data-testid={`manifesto-stat-${i}`}
        >
          <p className="font-display text-3xl font-semibold text-[#00e5ff] md:text-4xl">{s.v}</p>
          <p className="mt-2 font-mono-spec text-[10px] uppercase tracking-[0.25em] text-slate-500">{s.l}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
